import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgAdd = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 .016a2.976 2.976 0 00-2.976 2.976v6.032H2.992a2.976 2.976 0 100 5.952h6.032v6.032a2.976 2.976 0 105.952 0v-6.032h6.032a2.976 2.976 0 100-5.952h-6.032V2.992A2.976 2.976 0 0012 .016z" })));
};
export default SvgAdd;
//# sourceMappingURL=Add.js.map